// a react-three-fiber scene
import { softShadows } from "@react-three/drei";

import React, {
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { Suspense } from "react";
import * as T from "three";
import { useDrag } from "@use-gesture/react";

softShadows();
const PlanetMass = 10;
export default function Scene9() {
  return (
    <div style={{ height: "100%" }}>
      <Suspense falllback={null}>
        <ambientLight></ambientLight>
        <Canvas
          shadows
          onCreated={({ gl }) => {
            gl.setClearColor("black");
          }}
          camera={{ position: [0, 25, 0], fov: 35 }}
        >
          <Suspense falllback={null}>
            <Inner />
          </Suspense>
        </Canvas>
      </Suspense>
    </div>
  );
}

function DragPlane({ addStar }) {
  let target = useRef();
  let target2 = useRef();
  const { size, viewport } = useThree();
  const aspect = size.width / viewport.width;
  let screenToWorld = useCallback(
    ([x, y]) => {
      return new T.Vector3(
        x / aspect - viewport.width / 2,
        0,
        y / aspect - viewport.height / 2
      );
    },
    [viewport, aspect]
  );
  let bind = useDrag(
    ({ movement: [x, y], down, initial }) => {
      let worldPos = screenToWorld(initial);
      let offset = new T.Vector3(x / aspect, 0, y / aspect);
      offset.add(worldPos);

      if (!down) {
        console.log("NOT DOWN!");
        addStar({
          position: worldPos,
          velocity: offset.sub(worldPos).multiplyScalar(-4),
        });
        target.current.visible = false;
        target2.current.visible = false;
      } else {
        target.current.visible = true;
        target2.current.visible = true;
        target.current.position.copy(worldPos);
        target2.current.position.copy(offset);
      }
    },
    {
      eventOptions: { pointer: true },
    }
  );
  return (
    <>
      <mesh {...bind()} position={[-10, 0, 0]}>
        <boxBufferGeometry args={[100, 0, 100]}></boxBufferGeometry>
      </mesh>
      <mesh ref={target}>
        <sphereBufferGeometry args={[0.2, 16, 16]}></sphereBufferGeometry>
        <meshNormalMaterial></meshNormalMaterial>
      </mesh>
      <mesh ref={target2}>
        <sphereBufferGeometry args={[0.2, 16, 16]}></sphereBufferGeometry>
        <meshNormalMaterial></meshNormalMaterial>
      </mesh>
    </>
  );
}

function Inner() {
  let [stars, setStars] = useState([]);
  // let { camera } = useThree();
  /*const { zoom } = useControls({
    zoom: {
      value: 1,
      onChange: (v) => {
        camera.zoom = v;
        camera.updateProjectionMatrix();
      },
    },
  });*/
  return (
    <>
      <Planet></Planet>
      {stars.map((s, i) => {
        return (
          <Star
            position={s.position}
            velocity={s.velocity}
            key={i}
            color="white"
          ></Star>
        );
      })}
      <DragPlane addStar={(v) => setStars([...stars, v])}></DragPlane>
    </>
  );
}

function Planet() {
  return (
    <mesh castShadow receiveShadow>
      <sphereBufferGeometry args={[1, 32, 32]}></sphereBufferGeometry>
      <meshStandardMaterial color={"white"}></meshStandardMaterial>
    </mesh>
  );
}

function Star({ color, position, velocity }) {
  const ref = useRef();
  const data = useMemo(
    () => ({
      position: position,
      velocity: velocity,
      mass: 1,
    }),
    [position, velocity]
  );

  useFrame(({ testState }, delta) => {
    if (ref.current) {
      //calculate force acting upon the body
      let forceDirection = data.position.clone().normalize();
      let forceMag =
        ((1 * (PlanetMass * data.mass)) / data.position.length()) *
        data.position.length();
      data.velocity.sub(forceDirection.multiplyScalar(forceMag * delta));
      data.position.add(data.velocity.clone().multiplyScalar(delta));
      ref.current.position.copy(data.position);
    }
  });
  return (
    <mesh ref={ref} position={data.position} castShadow receiveShadow>
      <pointLight
        intensity={0.2}
        decay={1}
        distance={20}
        color={color}
      ></pointLight>
      <sphereBufferGeometry args={[0.2, 32, 32]}></sphereBufferGeometry>
      <meshStandardMaterial color={color}></meshStandardMaterial>
    </mesh>
  );
}
